const LIGHT_MODULES = [9, 11, 26, 37];

module.exports = {
  LIGHT_MODULES,
};
